import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Aguarde ", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_component = _resolveComponent("game-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.gameData.isInitiated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_game_component, { gameData: _ctx.gameData }, null, 8, ["gameData"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}